import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logout } from '../slices/user';

const baseQuery = fetchBaseQuery({
  baseUrl: "",
  credentials: 'include',
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("token");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  }
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result.error) {
    const status = result.error.status;
    const msg = result.error.data?.message;
    const isInactive = result.error.data?.isInactive;
    const shouldLogout = result.error.data?.logout;

    if (
      isInactive ||
      shouldLogout ||
      status === 401 ||
      (status === 403 && (msg === 'Invalid token' || msg === 'No token provided'))
    ) {
      const url = typeof args === 'string' ? args : args?.url;
      if (url && !url.includes('/login')) {
        api.dispatch(logout());
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
  }
  return result;
};

export const apiSlice = createApi({ 
    baseQuery: baseQueryWithReauth,
    tagTypes: ['products', 'inventory', 'brands', 'categories', 'invoices', 'customers', 'stock', 'saleman', 'units', 'producttypes', 'subcategories', 'users', 'roles'],
    endpoints: (builder) => ({})
});